import React from 'react';

import CommonNode from '../../../components/node/common-node';
import { NodeProvider } from '../../../context/node-context';
import BrightSpaceValenceApiReaderForm from '../forms/brightspace-valence-api-reader-form';
import { brightSpaceValenceApiReaderValidationSchema } from '../schema/brightSpaceValenceApiReader.js';

export default function BrightSpaceValenceApiReaderNode({ data, id, type }) {
  return (
    <NodeProvider
      nodeData={data}
      id={id}
      type={type}
      metaData={{
        modalTitle: data?.label || 'BrightSpaceValenceApi Reader Node Details',
        altText: 'BrightSpaceValenceApi Reader Node',
        defaultLabel: 'BrightSpaceValenceApi Reader Node',
      }}
    >
      <CommonNode
        FormComponent={BrightSpaceValenceApiReaderForm}
        schemaResolver={brightSpaceValenceApiReaderValidationSchema}
      />
    </NodeProvider>
  );
}
